module.exports = __webpack_public_path__ + "img/08.7e7deff1.jpg";